import React from 'react';
import css from './TopbarPromoBanner.module.css';

const TopbarPromoBanner = () => {
    return (
        <div className={css.banner}>
            <span className={css.text}>
                NO MONTHLY FEE
            </span>

            <span
                className={css.separator}
                aria-hidden="true"
            />

            <a
                href="https://calendar.app.google/a7Qfcyd1zB3CVSpL8"
                className={css.cta}
                target="_blank"
                rel="noopener noreferrer"
            >
                BOOK YOUR FREE DEMO NOW
            </a>
        </div>
    );
};

export default TopbarPromoBanner;
